import React, { Component } from "react";

class Faq extends Component {
  render() {
    return (
      <div>
        <section id="faq">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 text-center">
                <h2 className="section-title">Frequently Asked Questions</h2>
              </div>
            </div>{" "}
            {/* END row*/}
            <div className="row">
              <div
                className="col-md-6 faq-block wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay=".1s"
              >
                <h4>Q: How do I use synthCity?</h4>
                <p>
                  Download presets which you can use to learn sound design. Practice sound design by
                  solving challenges. Finally, complete the cycle by raising sound design challenges
                  back at the community.
                </p>
              </div>{" "}
              {/* END col-md-6 */}
              <div
                className="col-md-6 faq-block wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay=".3s"
              >
                <h4>Q: How do I help out?</h4>
                <p>
                  Answer EVERY poll! Polls are how new features are decided. For a feature to be
                  developed, a majority of the community must vote on it (usually two-thirds). If a
                  poll is put out and you do not vote, it is assumed you do not want the feature and
                  IT WILL NOT BE IMPLEMENTED.
                </p>
              </div>{" "}
              {/* END col-md-6 */}
            </div>{" "}
            {/* END row*/}
            <div className="row">
              <div
                className="col-md-6 faq-block wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay=".4s"
              >
                <h4>Q: Do I have to have my own synthesizer software?</h4>
                <p>
                  Yes, you'll need the relevant synthesizer to use the preset associated with it.
                </p>
              </div>{" "}
              {/* END col-md-6 */}
              <div
                className="col-md-6 faq-block wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay=".4s"
              >
                <h4>Q: Which synthesizers do you currently support?</h4>
                <p>
                  If you would like your synthesizer supported,{" "}
                  <a href="mailto:info@mazinomedia.com?subject=Request - Please add this synthesizer to synthCity&body=Synthesizer Name is: %0D%0A %0D%0ASynthesizer's Format is: ">
                    <b>request it here</b>
                  </a>
                </p>
              </div>{" "}
              {/* END col-md-6 */}
            </div>
            <div className="row">
              <div
                className="col-md-6 faq-block wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay=".4s"
              >
                <h4>Q: There's a feature that I'd like but isn't there.</h4>
                <p>
                  If you have a feature request or think something could be improved{" "}
                  <b>
                    <a href="mailto:info@synthcity.io">send me an email</a>
                  </b>
                  !
                </p>
              </div>{" "}
              {/* END col-md-6 */}
              <div
                className="col-md-6 faq-block wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay=".4s"
              >
                <h4>Q: I'm worried my feedback would hurt your feelings...</h4>
                <p>
                  For emotional support, We've got a designated crying area and all 16 seasons of Dr
                  Phil.
                </p>
              </div>{" "}
              {/* END col-md-6 */}
            </div>{" "}
            {/* END row*/}
          </div>{" "}
          {/* END contaier*/}
        </section>{" "}
        {/* END faq*/}
      </div>
    );
  }
}

export default Faq;



// WEBPACK FOOTER //
// ./src/components/synthcity/landing/Faq.js